import request from '@/utils/request'
const apiPath = '/sys/sysProfitRatio'
const sysProfitRatioApi = {
  /**
   * 新增【系统分利配置】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【系统分利配置】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  /**
   * 列表查询【系统分利配置】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  /**
   * 查询【系统分利配置】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/tee/listForMini`, { params: query })
  },
  /**
   * 查看【系统分利配置】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  }
}
export default sysProfitRatioApi
